import React from 'react';
import useUtilizationPerYearTotalChart from './hooks/useUtilizationPerYearTotalChart';
import { SimpleBars } from '../../../Common/Charts/SimpleBars';

export const UtilizationPerYearTotal = ({ height }) => {
    const { series, subtitles } = useUtilizationPerYearTotalChart();

    return (
        <SimpleBars
            height={height}
            decimals={0}
            series={series}
            values={[]}
            subtitles={subtitles}
            title={`Soma da Utilização Mensal por Ano`}
        />
    );
};
